import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\n",{ moduleName: "seshy/templates/authenticated/teams/show/projects.hbs" })